import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import { Fn_AddEditData } from "../../store/functions";
import Loader from "pages/Reports/loader";

class OfflineEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {
        VoucherNo: "",
        SenderMobileNo: 0,
        AccountNo: "",
        IFSC: "",
        AccountHolderName: "",
        BankName: "",
        Amount: 0,
        Charges: 0
        
      },
      isloading : false
    };
    this.obj = this
    this.breadCrumbTitle = "Offline Entry";
    this.breadCrumbItem = "Add Entry";
    this.API_URL_SAVE = "/api/saveOfflineEntry"; // Update with your actual API URL
    this.pushFormName = "/pendingcharges";

    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);

  }

  btnSave_onClick(event, values) {
    this.setState({isloading : true});
    const {
      VoucherNo,
      SenderMobileNo,
      AccountNo,
      IFSC,
      AccountHolderName,
      BankName,
      Amount,
      Charges,
    } = values;

    const obj = JSON.parse(sessionStorage.getItem("authUser"));
    const userId = (obj && obj.uid) ? obj.uid : 213;

    const vformData = new FormData();
    vformData.append("VoucherNo", VoucherNo);
    vformData.append("SenderMobileNo", SenderMobileNo);
    vformData.append("AccountNoMomai", AccountNo);
    vformData.append("IFSCMomai", IFSC);
    vformData.append("AccountHolderNameMomai", AccountHolderName);
    vformData.append("BankNameMomai", BankName);
    vformData.append("AmountMomai", Amount);
    vformData.append("Charges", Charges);
    vformData.append("Mode", 'Offline');
    vformData.append("UserIdMomai", userId);

    // Perform API call here
    Fn_AddEditData(
         this.obj,
         { arguList: { id: 0, formData: vformData } },
         "InsertVoucherAuto/0/token",
         this.pushFormName,
         true,
         "offline"
       );
  }

  btnGoBack_onClick = (event) => {
    event.preventDefault();
    this.props.history.push(this.pushFormName);
  };

  render() {
    const { formData } = this.state;

    return (
      <React.Fragment>
        
        <div className="page-content">
        {this.state.isloading ? <Loader/> : null}
          <Container fluid>
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <AvForm onValidSubmit={this.btnSave_onClick}>
                      <Row>
                        <Col lg="2">
                          <AvField
                            name="VoucherNo"
                            label="Voucher No"
                            value={formData.VoucherNo}
                            placeholder="Enter Voucher No"
                            type="text"
                            validate={{ required: { value: true } }}
                          />

                          </Col>

                          <Col lg="2">
                          <AvField
                            name="SenderMobileNo"
                            label="Sender Mobile No"
                            value={formData.SenderMobileNo}
                            placeholder="Enter Sender Mobile No"
                            type="number"
                            validate={{ required: { value: true } }}
                          />
                          </Col>
                          </Row>
                          <Row>
                          <Col lg="2">
                          <AvField
                            name="AccountNo"
                            label="Account No"
                            value={formData.AccountNo}
                            placeholder="Enter Account No"
                            type="text"
                          />
                          </Col>
                          <Col lg="2">
                          <AvField
                            name="IFSC"
                            label="IFSC"
                            value={formData.IFSC}
                            placeholder="Enter IFSC"
                            type="text"
                          />
                          </Col>
                          </Row>
                          <Row>
                          <Col lg="2">
                          <AvField
                            name="AccountHolderName"
                            label="Account Holder Name"
                            value={formData.AccountHolderName}
                            placeholder="Enter Account Holder Name"
                            type="text"
                          />
                          </Col>
                         
                          <Col lg="2">
                          <AvField
                            name="BankName"
                            label="Bank Name"
                            value={formData.BankName}
                            placeholder="Enter Bank Name"
                            type="text"
                          />
                          </Col>
                          </Row>
                         <Row>
                          <Col lg="2">
                          <AvField
                            name="Amount"
                            label="Amount"
                            value={formData.Amount}
                            placeholder="Enter Amount"
                            type="number"
                            validate={{ required: { value: true } }}
                          />
                          </Col>
                          <Col lg="2">
                          <AvField
                            name="Charges"
                            label="Charges"
                            value={formData.Charges}
                            placeholder="Enter Charges"
                            type="number"
                            defaultValue="0"
                          />
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button
                          type="submit"
                          color="primary"
                          className="mr-2"
                        >
                          Save
                        </Button>
                        {" "}
                        <Button
                          type="button"
                          color="secondary"
                          onClick={this.btnGoBack_onClick}
                        >
                          Go Back
                        </Button>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(container)(OfflineEntry);